"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersRequestBuilder = void 0;
var tslib_1 = require("tslib");
var QueryBuilder_1 = require("../QueryBuilder/QueryBuilder");
var MembersRequestBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(MembersRequestBuilder, _super);
    function MembersRequestBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = {
            name: 'nickname',
        };
        _this.newFields = {
            name: 'profile.nickname',
        };
        return _this;
    }
    /**
     * overrides query field names if API changed with experiment
     * remove usages if an experiment is ended
     * and change default field names `this.fields` appropriately
     * @param {Partial<MembersRequestFields>} fieldNames
     * @return {this}
     */
    MembersRequestBuilder.prototype.withFieldNames = function (fieldNames) {
        Object.assign(this.fields, fieldNames);
        return this;
    };
    MembersRequestBuilder.prototype.replaceFieldNames = function (fieldNames) {
        var filter = this.query.filter;
        if (!filter) {
            return this;
        }
        for (var key in fieldNames) {
            var oldKey = this.fields[key];
            var newKey = fieldNames[key];
            var value = filter[oldKey];
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete filter[oldKey];
            filter[newKey] = value;
        }
        return this.withFieldNames(fieldNames);
    };
    /**
     * add filter with members ids
     * {
     *    "query": {
     *      "filter": {
     *        "id": {
     *          "$in" : ["0f0e8afc-fb2e-4e35-9645-db34ac8b129b", "c1d92c76-371f-43c4-9070-a5a76ad9e84d"]
     *        }
     *      }
     *    }
     *  }
     * @return {QueryBuilder<wrapper.wix.social.groups.api.v1.QueryGroupMembersRequest>}
     */
    MembersRequestBuilder.prototype.filterWithIds = function ($in) {
        return this.addFilter({ id: { $in: $in } });
    };
    MembersRequestBuilder.prototype.filterWithNames = function ($in) {
        var _a;
        return this.addFilter((_a = {}, _a[this.fields.name] = { $in: $in }, _a));
    };
    MembersRequestBuilder.prototype.filterNameContains = function ($contains) {
        var _a;
        if (!$contains) {
            return this;
        }
        var fields = this.newFields;
        return this.addFilter((_a = {}, _a[fields.name] = { $contains: $contains }, _a));
    };
    MembersRequestBuilder.prototype.filterWithRoles = function ($in) {
        if (!$in) {
            return this;
        }
        return this.addFilter({ roles: { $in: $in } });
    };
    MembersRequestBuilder.prototype.sortByJoinDate = function (order) {
        if (order === void 0) { order = null; }
        // TODO: https://jira.wixpress.com/browse/GROUP-3600
        return this.addSort('joinedOn', order);
    };
    return MembersRequestBuilder;
}(QueryBuilder_1.QueryBuilder));
exports.MembersRequestBuilder = MembersRequestBuilder;
//# sourceMappingURL=MembersRequestBuilder.js.map